import React from "react";
import { ImpulseSpinner } from "react-spinners-kit";

const LOADER_STYLES = {
  height: "80vh",
  width: "100%",
  background: "#121212",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",

}

const Loader = () => (
  <div style={LOADER_STYLES}>
    <ImpulseSpinner
      size={70}
      backColor="#fff"
      frontColor="#808080"
    />
  </div>
);

export default Loader;